import React from 'react';
import replaceDotWithComma from '../../../../helpers/utils/replaceDotWithComma';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
      hintInfo =  calc.state.model.selectedType === 'loyal_schema_five' ? (
          <div className='star-info' dangerouslySetInnerHTML={{__html: calc.l10n("CREDIT_QUICK_CASH_CALCULATOR_HINT_INFO")}}></div>
        )
        : '';

    return (
        <React.Fragment>
            <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER_NEW')}</div>
            <div className="main-result">
                <p className="monthly-payment">
                    {calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}
                </p>
                <p className="monthly-payment-value">
                    {model.getRequiredPayment().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
                </p>
            </div>

            <div className={`loan-conditions ${calc.props.type}`}>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW')}
                        {model.getCreditSum().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_NEW')}
                        {replaceDotWithComma(model.getRealRate())}
                        {calc.l10n('CALCULATOR_CREDIT_PERCENT')}
                    </p>

                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('AUTO_LEASING_CALCULATOR_OVERPAYMENT_NEW')}
                        {model.getOverpayment().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_TOTAL_COST_NEW')}
                        {model.getCreditCost().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
                    </p>

                </div>
            </div>
        </React.Fragment>
    );
}
